import { Injectable } from "@angular/core";
import { Units } from "@models/units.model";

@Injectable({
  providedIn: 'root',
})

export class RoundingService {
  private DECIMAL_PLACES = [3, 2, 4, 5];

  public Round(value: number, units: Units): number {
    let maximumDecimalPlaces: number = this.DECIMAL_PLACES[units as number];

    const divisor = Math.pow(10, maximumDecimalPlaces);
    const rounded = value * divisor * 10;
    const converted = rounded.toFixed();
    return Math.ceil(parseInt(converted) / divisor) / 10;
  }

}
